export default __webpack_public_path__ + "static/media/avatar3.5a93ac4e.png";